'use strict';

require('../../picker-view/style/');

require('./index.less');